import { useState, useEffect } from "react";
import Sidebar from "../../components/Sidebar";
import "./client.css";
import { clients as initialClients } from "../../constant/dummy";
import { useNavigate } from "react-router-dom";
import { localStorageKey } from "../../constant/strings";
import Pagination from "../../components/Pagination";
import CommonLoader from "../../components/CommonLoader";

// Sub-components
import ClientTable from "./components/ClientTable";
import ClientModal from "./components/ClientModal";

export default function ClientPage() {
  const [clients, setClients] = useState([]);
  const [isModalOpen, setModalOpen] = useState(false);
  const [selectedClient, setSelectedClient] = useState(null);
  const [loading, setLoading] = useState(false);
  
  const navigation = useNavigate();
  const loginType = localStorage.getItem(localStorageKey.userType) || "accountant";

  const [page, setPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(10);

  const fetchData = async () => {
    setLoading(true);
    // Simulate API call to fetch data on every mount/switch
    try {
      await new Promise(resolve => setTimeout(resolve, 800)); // Simulate network delay
      setClients([...initialClients]);
    } catch (error) {
      console.error("Failed to fetch clients:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  const totalPages = Math.ceil(clients.length / itemsPerPage);
  const displayedClients = clients.slice(
    (page - 1) * itemsPerPage,
    page * itemsPerPage,
  );

  const handleEditClient = (client) => {
    setSelectedClient(client);
    setModalOpen(true);
  };

  const handleClientSubmit = async (formData) => {
    setLoading(true);
    try {
      // Simulate API call
      await new Promise(resolve => setTimeout(resolve, 1000));
      
      if (selectedClient) {
        // Update local state (mock)
        const updatedClients = clients.map((c) =>
          c.email === selectedClient.email
            ? { ...c, name: formData.fullName, company: formData.company, email: formData.email, phone: formData.phone }
            : c
        );
        setClients(updatedClients);
      } else {
        // Add local state (mock)
        const newClient = {
          company: formData.company,
          name: formData.fullName,
          email: formData.email,
          invited: new Date().toLocaleDateString("en-GB"),
          totalSales: "£ 0",
          phone: formData.phone
        };
        setClients([newClient, ...clients]);
      }
      setModalOpen(false);
      setSelectedClient(null);
    } catch (error) {
      alert("Failed to save client. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="app">
      <Sidebar />
      <CommonLoader visible={loading} />
      
      <main className="main-content">
        <div className="clients-header">
          <div>
            <h1>Clients</h1>
            <p>Manage your Company's Clients relationships and invitations.</p>
          </div>
          {loginType !== "accountant" && (
            <button 
              className="btn btn-primary" 
              onClick={() => { setSelectedClient(null); setModalOpen(true); }}
              disabled={loading}
            >
              + Add Client
            </button>
          )}
        </div>

        <div className="card">
          <div style={{ padding: "20px 24px", borderBottom: "1px solid #e5e7eb" }}>
            <h3 style={{ margin: 0, fontSize: "16px", fontWeight: 600 }}>All Clients</h3>
          </div>
          
          <ClientTable 
            clients={displayedClients} 
            page={page} 
            itemsPerPage={itemsPerPage} 
            onEdit={handleEditClient} 
          />
        </div>

        {clients.length > 0 && (
          <div style={{ marginTop: "24px" }}>
            <Pagination
              currentPage={page}
              totalPages={totalPages}
              onPageChange={setPage}
              totalItems={clients.length}
              itemsPerPage={itemsPerPage}
              onPageSizeChange={(newSize) => {
                setItemsPerPage(newSize);
                setPage(1);
              }}
            />
          </div>
        )}

        <ClientModal 
          isOpen={isModalOpen} 
          onClose={() => { setModalOpen(false); setSelectedClient(null); }}
          client={selectedClient}
          onSubmit={handleClientSubmit}
          loading={loading}
        />
      </main>
    </div>
  );
}
